module.exports = __webpack_public_path__ + "img/logo.a0932cef.png";